import { Button, Input, message } from 'antd';
import React, { useState } from 'react';
import useSetStep from './useSetStep';
import { StepOrder } from './types';
import useScavenger from './useScavenger';

interface Props {
  acceptedClues: string[];
  prompt?: string;
  text?: string;
}

const NextButton: React.FC<Props> = ({ acceptedClues, prompt, text }) => {
  const [value, setValue] = useState<string>('');
  const [messageApi, contextHolder] = message.useMessage();
  const scavenger = useScavenger();
  const { setStep } = useSetStep();
  if (scavenger.currentStep === StepOrder[StepOrder.length - 1]) {
    return null;
  }

  const handleClick = () => {
    if (acceptedClues.length && !acceptedClues.includes(value.toLowerCase())) {
      messageApi.error({
        type: 'warning',
        content: "Sorry that's not quite right...",
      });
    } else {
      const curIndex = StepOrder.findIndex((i) => i === scavenger.currentStep);
      setStep(StepOrder[curIndex + 1]);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 8,
        width: '100%',
        marginTop: 12,
      }}
    >
      {prompt && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <p style={{ margin: 0 }}>{prompt}</p>
          <Input style={{}} onChange={(e) => setValue(e.target.value)} />
        </div>
      )}
      <Button type='primary' size='large' onClick={handleClick}>
        {text ?? 'Next'}
      </Button>
      {contextHolder}
    </div>
  );
};

export default NextButton;
